import React from "react";
import { OrgHomeCompact } from "./OrgHomeCompact";
import { OrgHomeRegular } from "./OrgHomeRegular";
import { PortalHost } from "@gorhom/portal";
import { Platform } from "react-native";
import { ORG_HOME_PORTAL_NAME } from "./ORG_HOME_PORTAL_NAME";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";

export function OrgHome() {
  return (
    <>
      <LazyQueryNetworkBoundrary>
        {(fk) =>
          Platform.OS !== "web" ? (
            <OrgHomeCompact />
          ) : (
            <OrgHomeRegular fetchKey={fk} />
          )
        }
      </LazyQueryNetworkBoundrary>

      <PortalHost name={ORG_HOME_PORTAL_NAME} />
    </>
  );
}
